import { parse } from "date-fns";

export function useAppointmentServiceTime(date: string, time: string) {
  return parse(`${date} ${time}`, 'yyyy-MM-dd HH:mm', new Date()) || new Date()
}